import urlJoin from 'url-join';
import { applicationSteps } from 'QuoteApp/components/Router';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { QUOTE_APP_ROUTE } from 'Shared/constants/routes';

export const useFooter = (currentStepIndex: number) => {
  const { push } = useHistory();
  const match = useRouteMatch<{ appId: string }>();

  const nextStep = applicationSteps[currentStepIndex + 1];
  const previousStep = applicationSteps[currentStepIndex - 1];

  const successHandler = (path: string) => {
    push(urlJoin(QUOTE_APP_ROUTE, match?.params.appId || '', path));
  };

  return {
    previousStep: {
      onClickSuccess: () => successHandler(previousStep?.path),
      text: `Back: ${previousStep?.display}`,
    },
    nextStep: {
      onClickSuccess: () => successHandler(nextStep?.path),
      text: `Next: ${nextStep?.display}`,
    },
  };
};
